module.exports = __webpack_public_path__ + "img/about-us-3.ee28d2f2.jpg";